import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {updateHouseholdIncomeRange} from '../actions/student';
import AverageNetPricePerHouseholdIncome from '../components/about-college/cost-and-financial-aid/average-net-price-per-household-income';

const mapDispatchToProps = (dispatch) => bindActionCreators({updateHouseholdIncomeRange}, dispatch);

export default connect(null, mapDispatchToProps)(AverageNetPricePerHouseholdIncome);
